import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="42" height="43" viewBox="0 0 42 43" fill="none" {...props}>
      <rect y="0.810059" width="42" height="42" rx="21" fill="#286EFA" />
      <path
        d="M25.851 15H28.1503L23.102 20.7481L29 28.5455H24.3715L20.7478 23.8071L16.5991 28.5455H14.2999L19.6481 22.3975L14 15H18.7434L22.0173 19.3286L25.851 15ZM25.0463 27.1959H26.3209L18.0736 16.2996H16.7041L25.0463 27.1959Z"
        fill="white"
      />
    </Svg>
  )
}
